<template>
  <div>
    <Form
      :form="form"
      :model="form"
      :rules="validatorRules"
      style="max-width: 500px; margin: 40px auto 0;"
    >
      <form-item label="账号名" props="username">
        <i-input
          type="text"
          autocomplete="false"
          :style="{width:'310px'}"
          :value="accountName"
          v-model="form.accountName"
          disabled
        ></i-input>
      </form-item>
      <form-item label="手机" props="phone">
        <i-input
          type="text"
          :value="hidePhone(phone)"
          autocomplete="false"
          :style="{width:'310px'}"
          placeholder="请输入手机号"
          disabled
        ></i-input>
      </form-item>
      <form-item props="inputCode" label="验证码" v-if="show">
        <Row style="margin-left: 2px">
          <i-col class="gutter-row" span="10">
            <i-input type="text" v-model="form.inputCode" placeholder="手机短信验证码"></i-input>
          </i-col>
          <i-col class="gutter-row" span="10">
            <a
              class="submit"
              style="width:80%"
              tabindex="-1"
              size="small"
              :disabled="state.smsSendBtn"
              @click.stop.prevent="getCaptcha"
              v-text="!state.smsSendBtn && '获取验证码' || (state.time+' s')"
            ></a>
          </i-col>
        </Row>
      </form-item>
      <form-item>
        <a class="submit" style="margin-left: 8px" @click="prevStep">上一步</a>
        <a class="submit" type="primary" @click="nextStep" style="margin-left: 20px">下一步</a>
      </form-item>
    </Form>
  </div>
</template>

<script>
import request from "@/api/axios";

export default {
  name: "Step2",
  props: ["userList"],
  data() {
    return {
      form: {
        accountName: this.userList.username,
        phone: this.userList.phone,
        inputCode: "",
      },
      loading: false,
      accountName: this.userList.username,
      phone: this.userList.phone,
      dropList: "0",
      captcha: "",
      show: true,
      state: {
        time: 60,
        smsSendBtn: false,
      },
      formLogin: {
        captcha: "",
        mobile: "",
      },
      validatorRules: {
        inputCode: {
          rule: [
            { required: true, message: "请输入短信验证码!" },
            { validator: this.validateCaptcha },
          ],
        },
        phone: { rule: [{ required: true, message: "请输入手机号码!" }] },
      },
    };
  },
  created() {},
  computed: {
    defaultPhone: function () {
      if (this.userList.isPhone) {
        return this.userList.phone;
      }
      return null;
    },
  },
  methods: {
    hidePhone(val){
      return `${val.substring(0,3)}****${val.substring(val.length-2)}`
    },
    nextStep() {
      let that = this;
      that.loading = true;
      // this.form.validateFields((err, values) => {
      //   console.log(values);
      //   if (!err) {
      if (that.dropList == "0") {
        console.log(that.form.inputCode);
        if (that.form.inputCode == undefined || that.form.inputCode == "") {
          this.cmsFailed("请输入短信验证码!");
        } else {
          var params = {};
          params.phone = this.userList.phone;
          params.smscode = that.form.inputCode;
          request({
            url: "/api/sys/user/phoneVerification",
            method: "post",
            data: params,
          }).then((res) => {
            if (res.success) {
              console.log(res);
              var userList = {
                username: this.userList.username,
                phone: this.userList.phone,
                smscode: this.form.inputCode,
              };
              setTimeout(function () {
                that.$emit("nextStep", userList);
              }, 0);
            } else {
              this.cmsFailed(res.message);
            }
          });
        }
      }
      //   }
      // });
    },
    prevStep() {
      this.$emit("prevStep", this.userList);
    },
    getCaptcha(e) {
      e.preventDefault();
      let that = this;
      this.state.smsSendBtn = true;
      let interval = window.setInterval(() => {
        if (that.state.time-- <= 0) {
          that.state.time = 60;
          that.state.smsSendBtn = false;
          window.clearInterval(interval);
        }
      }, 1000);

      const hide = this.$Message.loading("验证码发送中..", 0);
      let smsParams = {
        mobile: this.userList.phone,
        smsmode: "2",
      };
      request({ url: "/api/sys/sms", method: "post", data: smsParams }).then(
        (res) => {
          if (!res.success) {
            this.cmsFailed(res.message);
            setTimeout(hide, 1);
          }
          setTimeout(hide, 500);
        }
      );
    },
    cmsFailed(err) {
      this.$Message.info(err);
    },
    handleChangeSelect(value) {
      var that = this;
      console.log(value);
      if (value == 0) {
        that.dropList = "0";
        that.show = true;
      } else {
        that.dropList = "1";
        that.show = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.stepFormText {
  margin-bottom: 24px;
}

.ant-form-item-label,
.ant-form-item-control {
  line-height: 22px;
}

.getCaptcha {
  display: block;
  width: 100%;
  height: 40px;
}

.submit {
  height: 45px;
  line-height: 45px;
  background: rgba(0, 193, 222, 1);
  width: 45%;
  display: inline-block;
  color: #fff;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/common/Step2.vue